import { render, staticRenderFns } from "./Apropos.vue?vue&type=template&id=6c5507c6"
import script from "./Apropos.vue?vue&type=script&lang=js"
export * from "./Apropos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports